import classNames from "utils/class-names";
import { FILTER_TYPE } from "utils/constants";
import generatedFormatDate from "utils/generatedDate";

export const COLUMNS_DATA = ({ deleteRow, editInvoice, filters }) => [
  {
    Header: "S.No",
    accessor: "_index",
    disableSortBy: true,
    Cell: ({ row }) => row.index + 1,
  },
  {
    Header: "Appointment ID",
    accessor: "appointment_id",
    disableSortBy: true,
  },
  {
    Header: "Date",
    accessor: "generated",
    disableSortBy: true,
    Cell: ({ value }) => generatedFormatDate(value),
  },
  {
    Header: "Patient Name",
    accessor: "patient_obj.patient_name",
    disableSortBy: true,
  },
  {
    Header: "Registration No",
    accessor: "patient_obj.registration_no",
    disableSortBy: true,
  },
  {
    Header: "Gender",
    accessor: "patient_obj.gender",
    disableSortBy: true,
    Cell: ({ cell }) => (
      <span>{cell.value?.charAt(0).toUpperCase() + cell.value?.slice(1)}</span>
    ),
  },
  {
    Header: "Zone",
    accessor: "zone_name",
    disableSortBy: true,
  },
  {
    Header: "Franchise",
    accessor: "franchise_name",
    disableSortBy: true,
  },
  {
    Header: "Total MRP (₹)",
    accessor: "total_mrp_rate",
    disableSortBy: true,
    Cell: ({ cell }) => `₹${cell.value ?? 0}`,
  },
  {
    Header: "Discount (₹)",
    accessor: "discount_amount",
    disableSortBy: true,
    Cell: ({ cell }) => `₹${cell.value ?? 0}`,
  },
  {
    Header: "Final Amount (₹)",
    accessor: "final_amount",
    disableSortBy: true,
    Cell: ({ cell }) => `₹${cell.value ?? 0}`,
  },
  {
    Header: "Balance (₹)",
    accessor: "balance_amount",
    disableSortBy: true,
    Cell: ({ cell }) => <span>₹{cell.value ?? 0}</span>,
  },
  {
    Header: "Refund (₹)",
    accessor: "refund_amount",
    disableSortBy: true,
    Cell: ({ cell }) => (cell.value ? `₹${cell.value}` : "-"),
  },
  {
    Header: "Status",
    accessor: "appointment_obj.status",
    disableSortBy: true,
    Cell: ({ cell }) => (
      <span
        style={{
          padding: "4px 10px",
          borderRadius: "20px",
          fontSize: "12px",
          fontWeight: "600",
          backgroundColor:
            cell.value === "COLLECT & RECEVIED"
              ? "#d1fae5"
              : cell.value === "PENDING"
                ? "#fef9c3"
                : cell.value === "CANCELLED"
                  ? "#fee2e2"
                  : "#e0f2fe",
          color:
            cell.value === "COLLECT & RECEVIED"
              ? "#065f46"
              : cell.value === "PENDING"
                ? "#854d0e"
                : cell.value === "CANCELLED"
                  ? "#991b1b"
                  : "#0369a1",
        }}
      >
        {cell.value ?? "N/A"}
      </span>
    ),
  },
  {
    Header: "Created By",
    accessor: "created_by_name",
    disableSortBy: true,
  },
];

export const DETAIL_COLUMNS = () => [
  {
    Header: "S.No",
    accessor: "_index",
    disableSortBy: true,
    Cell: ({ row }) => row.index + 1,
  },
  {
    Header: "Cancellation ID",
    accessor: "cancellation_id",
    disableSortBy: true,
  },
  {
    Header: "Appointment ID",
    accessor: "appointment_id",
    disableSortBy: true,
  },
  {
    Header: "Date",
    accessor: "generated",
    disableSortBy: true,
    Cell: ({ value }) => generatedFormatDate(value),
  },
  {
    Header: "Patient Name",
    accessor: "patient_obj.patient_name",
    disableSortBy: true,
  },
  {
    Header: "Registration No",
    accessor: "patient_obj.registration_no",
    disableSortBy: true,
  },
  {
    Header: "DOB",
    accessor: "patient_obj.dob",
    disableSortBy: true,
  },
  {
    Header: "Gender",
    accessor: "patient_obj.gender",
    disableSortBy: true,
    Cell: ({ cell }) => (
      <span>
        {cell.value?.charAt(0).toUpperCase() + cell.value?.slice(1) ?? "N/A"}
      </span>
    ),
  },
  {
    Header: "Zone",
    accessor: "zone_name",
    disableSortBy: true,
  },
  {
    Header: "Franchise",
    accessor: "franchise_name",
    disableSortBy: true,
  },
  {
    Header: "Package Name",
    accessor: "package_obj.package_name",
    disableSortBy: true,
    Cell: ({ cell }) => cell.value ?? "N/A",
  },
  {
    Header: "Test Code",
    accessor: "package_obj.test_code",
    disableSortBy: true,
    Cell: ({ cell }) => cell.value ?? "N/A",
  },
  {
    Header: "Package Cost (₹)",
    accessor: "package_obj.package_cost",
    disableSortBy: true,
    Cell: ({ cell }) => (cell.value ? `₹${cell.value}` : "N/A"),
  },
  {
    Header: "MRP Rate (₹)",
    accessor: "mrp_rate",
    disableSortBy: true,
    Cell: ({ cell }) => `₹${cell.value ?? 0}`,
  },
  {
    Header: "Rate (₹)",
    accessor: "rate",
    disableSortBy: true,
    Cell: ({ cell }) => `₹${cell.value ?? 0}`,
  },
  {
    Header: "Appointment Status",
    accessor: "appointment_obj.status",
    disableSortBy: true,
    Cell: ({ cell }) => (
      <span
        style={{
          padding: "4px 10px",
          borderRadius: "20px",
          fontSize: "12px",
          fontWeight: "600",
          backgroundColor:
            cell.value === "COLLECT & RECEVIED"
              ? "#d1fae5"
              : cell.value === "PENDING"
                ? "#fef9c3"
                : cell.value === "CANCELLED"
                  ? "#fee2e2"
                  : "#e0f2fe",
          color:
            cell.value === "COLLECT & RECEVIED"
              ? "#065f46"
              : cell.value === "PENDING"
                ? "#854d0e"
                : cell.value === "CANCELLED"
                  ? "#991b1b"
                  : "#0369a1",
        }}
      >
        {cell.value ?? "N/A"}
      </span>
    ),
  },
  {
    Header: "Billing Category",
    accessor: "package_obj.billing_category",
    disableSortBy: true,
    Cell: ({ cell }) => cell.value ?? "N/A",
  },
  {
    Header: "Created By",
    accessor: "created_by_name",
    disableSortBy: true,
  },
];

export const BRANCH_FORM_CONFIG = (rowData) => [
  {
    label: "Branch",
    type: "input-text",
    name: "branch",
    defaultValue: rowData?.branch || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Branch Address",
    type: "input-text",
    name: "branch_address",
    defaultValue: rowData?.branch_address || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "City",
    type: "select",
    name: "city",
    defaultValue: rowData?.city || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "State",
    type: "select",
    name: "state",
    defaultValue: rowData?.state || "",
    options: [],
    validations: {
      required: true,
    },
  },
  {
    label: "PinCode",
    type: "input-text",
    name: "pincode",
    defaultValue: rowData?.pincode || "",
    validations: {
      maxLength: 6,
      required: true,
      pattern: {
        value: /^[0-9]+$/,
        message: "Please enter a valid PinCode",
      },
    },
  },
  {
    label: "Area Name",
    type: "input-text",
    name: "area_name",
    defaultValue: rowData?.area_name || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Zone",
    type: "select",
    name: "zone_id",
    defaultValue: rowData?.zone_name || "",
    options: [],
    validations: {
      required: true,
    },
  },
];

export const OPTIONS = [
  // { key: "patient_name", value: "Patient Name" },
  { key: "appointment_id", value: "Appointment ID" },
  { key: "barcode_id", value: "Barcode" },
  { key: "registration_no", value: "Reg No" },
  { key: "patient_bill_no", value: "Patient Bill No" },
];
export const STATUS_OPTIONS = [
  { key: true, value: "Active" },
  { key: false, value: "In-Active" },
];
export const FILTER_DEFINATIONS = [
  {
    name: "keyword",
    type: FILTER_TYPE.SELECT,
    initialValue: OPTIONS[0].key,
  },
  {
    name: "text",
    type: FILTER_TYPE.TEXT,
    initialValue: "",
    debounce: true,
  },
  {
    name: "is_active",
    type: FILTER_TYPE.SELECT,
    initialValue: STATUS_OPTIONS[0].key,
  },
];
